
export const checkPermission = (value: string[]): boolean => {
  if (value && value instanceof Array && value.length > 0) {
    const roles: any[] = []
    const permissionRoles = value
    const hasPermission = roles.some(role => {
      return permissionRoles.includes(role)
    })
    return hasPermission
  } else {
    console.error(`need roles! Like v-permission="['admin','editor']"`)
    return false
  }
}

// Функции для проверки прав доступа к файловому менеджеру
export const checkStorageAccess = (): boolean => {
  // Импортируем здесь, чтобы избежать циклических зависимостей
  const UserManagerService = require('@/services/data/user_manager').default;
  const storage_access = UserManagerService.current_user?.storage_access;
  console.log(storage_access, storage_access === 'read_and_edit' || storage_access === 'read_only')
  return storage_access === 'read_and_edit' || storage_access === 'read_only';
}

export const checkStorageEdit = (): boolean => {
  const UserManagerService = require('@/services/data/user_manager').default;
  const storage_access = UserManagerService.current_user?.storage_access;
  return storage_access === 'read_and_edit';
}

export const checkStorageRead = (): boolean => {
  const UserManagerService = require('@/services/data/user_manager').default;
  const storage_access = UserManagerService.current_user?.storage_access;
  return storage_access === 'read_and_edit' || storage_access === 'read_only';
}

export const getStorageAccessLevel = (): string => {
  const UserManagerService = require('@/services/data/user_manager').default;
  return UserManagerService.current_user?.storage_access || 'forbidden';
}
